<script setup lang="ts">
import type { WeekDayTile } from '../models';

interface WeekDayTileViewProps {
  calendarTile: WeekDayTile;
}

const props = defineProps<WeekDayTileViewProps>();
</script>

<template>
  <div class="week-day-tile-view">{{ props.calendarTile.text }}</div>
</template>

<style scoped lang="scss">
@use '../styles/price_calendar_mixins' as *;

.week-day-tile-view {
  color: var(--calendar-weekday-font-color);
  @include calendar-weekday-font;

  width: var(--calendar-tile-size);
  height: var(--calendar-tile-size);

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
